import React from "react"
import text from "../data/text.json"

import Layout from "../components/Layout"
import Wrapper from "../components/Common/Wrapper"
import Content from "../components/Common/Content"
import SEO from "../components/seo"
import { ImageContainer } from "../components/ImgQuery/styled.js"
import { HomeImage } from "../components/ImgQuery"
import { Title, TextSm, TextPCentered } from "../components/Text"
import { SmSplitter } from "../components/Splitter"

const HomeTxt = text.home

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />

    <Wrapper>
      <ImageContainer>
        <HomeImage />
      </ImageContainer>
      <Content>
        <header>
          <Title>{HomeTxt.title}</Title>
          <SmSplitter />
          <TextSm>{HomeTxt.mainText}</TextSm>
        </header>
        <SmSplitter />
        <TextPCentered>
          <TextSm>{HomeTxt.subText}</TextSm>
        </TextPCentered>
      </Content>
    </Wrapper>
  </Layout>
)

export default IndexPage
